module.exports = __webpack_public_path__ + "img/guam.3ebe266c.png";